// This file is AUTOGENERATED, do not edit it manually!!!

export const portfolios = {
    add_portfolio: 'Добавить портфолио',
    add_sub_portfolio: 'Добавить подпортфолио',
    copy_custom_fields_label: 'Скопировать дополнительные поля с родительского портфолио',
    delete_portfolio_title: 'Удалить портфолио \"{0}\"?',
    DeletionIsUsedDisabled: 'Нельзя удалить статус, т.к. существует портфолио с таким статусом.',
    Editor: 'Редактор портфолио',
    Manager: 'Менеджер портфолио',
    members: '7#{0} участник портфолио#{0} участника  портфолио#{0} участников портфолио',
    new_portfolio: 'Новое портфолио',
    NewStatusTitle: 'Добавить статус',
    ParentPortfolio: 'Родительское портфолио',
    permissions_title: 'Этот уровень доступа имеет следующие разрешения в отношении портфолио и проектов в нем',
    Portfolios: 'Портфолио',
    role_for_this_portfolio: 'Уровень доступа для данного портфолио:',
    Statuses: 'Статусы',
    Teamer: 'Участник портфолио',
    Viewer: 'Просмотр портфолио',
};
